import React, { createContext } from 'react';

import { UIKind } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';

export const defaultContext = {
  kind: UIKind.MOBILE,
};

const context = createContext<{ kind: UIKind }>(defaultContext);

const Provider = ({
  children,
  kind,
}: {
  children: React.ReactNode;
  kind?: UIKind | null;
}) => (
  <context.Provider
    value={{
      kind: kind ?? UIKind.MOBILE,
    }}
  >
    {children}
  </context.Provider>
);

export { Provider, context };
